import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import StaffLogin from "./pages/StaffLogin";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import AdminPanel from "./pages/AdminPanel";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminResetPassword from "./pages/AdminResetPassword";
import ResetPassword from "./pages/ResetPassword";
import MenuPage from "./pages/MenuPage";
import TablesPage from "./pages/TablesPage";
import StaffPage from "./pages/StaffPage";
import ReportsPage from "./pages/ReportsPage";
import WaiterPage from "./pages/WaiterPage";
import KitchenPage from "./pages/KitchenPage";
import SettingsPage from "./pages/SettingsPage";
import ManagerHome from "./pages/ManagerHome";
import FeeAgreementPage from "./pages/FeeAgreementPage";
import ClockPage from "./pages/ClockPage";
import OrderPage from "./pages/OrderPage";
import TrackPage from "./pages/TrackPage";
import OnlineOrderingPage from "./pages/OnlineOrderingPage";
import EmployeesPage from "./pages/EmployeesPage";
import AttendancePage from "./pages/AttendancePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/fee-agreement" element={<FeeAgreementPage />} />
        <Route path="/clock" element={<ClockPage />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/track" element={<TrackPage />} />
        <Route path="/online-ordering" element={<OnlineOrderingPage />} />
        <Route path="/employees" element={<EmployeesPage />} />
        <Route path="/attendance" element={<AttendancePage />} />
        <Route path="/waiter-login" element={<StaffLogin station="waiter" />} />
        <Route path="/kitchen-login" element={<StaffLogin station="kitchen" />} />
        <Route path="/manager-login" element={<StaffLogin station="manager" />} />
        <Route path="/manager-home" element={<ManagerHome />} />
        <Route path="/waiter" element={<WaiterPage />} />
        <Route path="/kitchen" element={<KitchenPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/tables" element={<TablesPage />} />
        <Route path="/staff" element={<StaffPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/reset-password" element={<AdminResetPassword />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
